<template>
  <div class="vendor-signup-page content">
    <h1>Partner with TANM</h1>
    <p class="note">Heads up: We’re still in early development. This platform is not publicly available yet — but we’re actively onboarding early vendors and shaping the future of food delivery together.</p>

    <div class="hero-box">
      <h2>Why Join TANM?</h2>
      <ul>
        <li><strong>Lower Commission:</strong> Keep more of your earnings — we don’t believe in eating your margins.</li>
        <li><strong>Real-Time Order Tracking:</strong> Just like Domino’s, but for everyone — powered by modern tech.</li>
        <li><strong>Stripe Payments:</strong> Easy, secure payments including Apple Pay, Google Pay, and more.</li>
        <li><strong>Your Branding:</strong> Customers see your name first — not just ours.</li>
        <li><strong>Designed for Small Teams:</strong> Built by a CTO who’s run lean, high-performing tech stacks for over a decade.</li>
      </ul>
    </div>

    <div class="cta-box">
      <p class="cta-text">
        Want to be one of the first vendors on the platform?
        <br />
        Your feedback and early adoption could shape the future of local food delivery.
      </p>
      <a href="https://admin.tanm.co.uk/signup"
         class="signup-btn"
         target="_blank"
         rel="noopener">
        Apply as a Vendor
      </a>
    </div>

    <p class="back-link">
      Not a vendor? <router-link to="/sign-up">Join the waitlist</router-link> instead.
    </p>
  </div>
</template>

<style scoped>
  .vendor-signup-page {
    max-width: 900px;
    margin: 0 auto;
    padding: 40px 20px;
  }

    .vendor-signup-page h1 {
      margin-top: 0;
      font-size: 32px;
    }

  .note {
    background: #fff3cd33;
    padding: 15px;
    border-left: 5px solid #ffc107;
    margin: 20px 0;
    border-radius: 5px;
    font-weight: 500;
  }

  .hero-box {
    background: #f8f9fa33;
    padding: 25px;
    border-radius: 8px;
    margin: 30px 0;
  }

    .hero-box h2 {
      margin-bottom: 15px;
    }

    .hero-box ul {
      list-style: disc;
      padding-left: 20px;
      line-height: 1.7;
    }

  .cta-box {
    text-align: center;
    margin: 40px 0;
  }

  .cta-text {
    font-size: 18px;
    margin-bottom: 20px;
  }

  .signup-btn {
    display: inline-block;
    background: #1989a3;
    color: white;
    font-weight: bold;
    padding: 14px 28px;
    border-radius: 8px;
    font-size: 18px;
    text-decoration: none;
    transition: background 0.3s ease;
  }

    .signup-btn:hover {
      background: #156b80;
    }

  .back-link {
    text-align: center;
    margin-top: 30px;
  }
</style>
